import React, { Component } from 'react';
import * as playlistReducers from "../../reducers/playlist";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as playlistActions from "../../actions/playlist";
import ReactImageFallback from "react-image-fallback";
import {IMGIX_PATH, PUB_PLAYER_PATH, UNPUB_PLAYER_PATH} from "../../constants";
class Lvignets extends Component {

    constructor(props) {
        super(props);
        this.listVignets = this.listVignets.bind(this);
    }
    componentDidMount()
    {
        this.listVignets();
    }

    listVignets(plId)
    {
        let data = { 'plId' : this.props.match.params.id  };
        this.props.getPlaylistVignets(data);
        this.props.getPlaylist(data);
    }

    render() {

        let playlist = this.props.playlistData? this.props.playlistData.playListDetail:undefined;
        let vignetsList = this.props.playlistData? this.props.playlistData.vignetsList:undefined;


        return (
            <div className="wrapper external">

                <div className="container">
                    <div className="playlist-wrapper">
                        <h1>{playlist?playlist.pl_name : ''}</h1>
                        <div className="playlist-list-wrap">
                            { (!vignetsList || vignetsList.length === 0) &&


                            <div className="alert alert-secondary text-center" role="alert">
                               No vignets added to this playlsit
                            </div>

                            }

                            { vignetsList && vignetsList.map((list) =>{

                                    list.imgSrc = IMGIX_PATH+'assets/slider/cf'+list.vignet_id+'.jpg?fit=crop&h=230&w=265&auto=enhance&dpr=3%203x';

                                    if(list.public_view === 1) {
                                        list.playerUrl = PUB_PLAYER_PATH+ list.vignet_id;
                                    }
                                    else{
                                        list.playerUrl = UNPUB_PLAYER_PATH+ list.vignet_id;
                                    }

                                return(
                                    <div className="ind-playlist-list">
                                        <a href={list.playerUrl} target="_blank">
                                            <div className="playlist-thumb">
                                                <ReactImageFallback
                                                    src={list.imgSrc}
                                                    fallbackImage={list.defImgSrc}
                                                    initialImage={list.defImgSrc}
                                                    alt="cool image should be here"
                                                    className="my-image"/>
                                            </div>
                                            <div className="playlist-desc">
                                                <h5>{list.vignet_title}</h5>
                                            </div>
                                        </a>
                                    </div>
                                );
                            }

                            )}
                        </div>
                    </div>
                </div>

            </div>


        );
    }
}
function mapStateToProps(state) {
    return {
        playlistData  :playlistReducers.getPlaylistData(state)
    };

}

export default  withRouter(connect(mapStateToProps,  {
    getPlaylist : playlistActions.getPlayListDetails,
    getPlaylistVignets : playlistActions.showPlaylistVignets,
})(Lvignets));




// WEBPACK FOOTER //
// ./src/components/playlist/ListVignets.js